export const DateRanges = {
  Last24h: 0,
  Last7Days: 1,
  Last30Days: 2,
  Last90Days: 3,
  Custom: 4,
}
export const Periods = {
  Daily: "Daily",
  Weekly: "Weekly",
  Monthly: "Monthly",
}

export const EventPagesList = [
  { text: "Live View", value: "LiveView" },
  { text: "Recordings", value: "Recordings" },
  { text: "Edit Tool", value: "EditTool" },
  { text: "Markup Tool", value: "MarkupTool" },
  { text: "XRay", value: "Xray" },
  { text: "Weather", value: "Weather" },
  { text: "Compare", value: "Compare" },
  { text: "Timelapse", value: "Timelapse" },
  { text: "Progress Photos", value: "ProgressPhoto" },
  { text: "Automations", value: "Automations" },
  { text: "Gate Report", value: "GateReport" },
  { text: "Bim", value: "Bim" },
  { text: "Bim Compare", value: "BimCompare" },
  { text: "360", value: "360" },
  { text: "Drone", value: "Drone" },
  { text: "Timeline", value: "Timeline" },
  { text: "Connectors", value: "Connectors" },
  { text: "Media", value: "Media" },
  { text: "Settings", value: "Settings" },
  { text: "Copilot", value: "Copilot" },
  { text: "Widgets", value: "Widgets" },
  { text: "Planner", value: "Planner" },
  { text: "Planner", value: "Planner" },
  { text: "Player", value: "Player" },
  { text: "Project", value: "Project" },
  { text: "All Projects", value: "AllProjects" },
  { text: "Sharing", value: "Sharing" },
  { text: "MediaHub", value: "MediaHub" },
  { text: "Page View", value: "PageView" },
  { text: "Media Overiew", value: "MediaOveriew" },
  { text: "VideoWall", value: "VideoWall" },
  { text: "Tutorials", value: "Tutorials" },
]

export const PosthogEventsTableHeaders = (self) => {
  let headers = []
  if (!self.email) {
    headers.push({
      value: "email",
      text: "Email",
      visible: true,
      width: 150,
    })
  }

  headers.push(
    {
      value: "name",
      text: "Event",
      visible: true,
      width: 100,
    },
    {
      value: "page",
      text: "Page",
      visible: true,
      width: 100,
    }
  )

  if (self.isDisplayedInternalData) {
    headers.push(
      {
        value: "context",
        text: "Context",
        visible: true,
        width: 100,
      },
      {
        value: "action",
        text: "Action",
        visible: true,
        width: 100,
        sortable: false,
      },
      {
        value: "ipAddress",
        text: "IP Address",
        visible: true,
        width: 100,
        sortable: false,
      },
      {
        value: "browser",
        text: "Browser",
        visible: true,
        width: 200,
        sortable: false,
      }
    )
  }

  if (!self.projectExid) {
    headers.push({
      value: "projectName",
      text: "Project",
      visible: true,
      width: 150,
    })
  }

  headers.push(
    {
      value: "cameraName",
      text: "Camera",
      visible: true,
      width: 150,
    },
    {
      value: "timestamp",
      text: "Date",
      visible: true,
      width: 150,
      toStringFn: (item, key) => self.formatDate(item[key]),
    }
  )

  return headers
}

export const PosthogEventsStatsTableHeaders = () => {
  let headers = [
    {
      value: "page",
      text: "Feature",
      visible: true,
      width: 100,
    },
    {
      value: "eventsCount",
      text: "Total",
      visible: true,
      width: 100,
    },
  ]

  return headers
}
